import api from '../callApi';

export const completeRadialSlider = (apiRequestData, actionCompletedTime, value) => {
    const request = {
        ...apiRequestData,
        actionCompletedTime,
        value
    };

    return api.post('Widget/CompleteSpeedometerAsync', request, { useFingerprint: true });
};

export const reanswerRadialSlider = (
    apiRequestData,
    actionCompletedTime,
    value,
    answerId
) => {
    const request = {
        ...apiRequestData,
        actionCompletedTime,
        value,
        answerId
    };

    return api.post('Widget/UpdateSpeedometerAsync', request, { useFingerprint: true });
};
